var render = function render(){var _vm=this,_c=_vm._self._c;return _c('template-view',_vm._g({directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"TemplateView",attrs:{"bizParams":_vm.viewBizParams,"config":_vm.config,"extraParams":_vm.extraParams,"formData":_vm.formData,"readOnly":_vm.readOnly}},_vm.bindEvents()))
}
var staticRenderFns = []

export { render, staticRenderFns }